<template>
  <div class="agent-center container"
       ref="containerBox"
       @scroll="handleScroll">
    <!-- 导航栏 -->
    <div ref="stickyBox"
         :class="[{ sticky: isSticky }, { box: !isSticky }]"
         :style="{ background: isSticky ? '#fff' : 'transparent' }">
      <titlePage :isSticky="isSticky"
                 :scrollToTop="scrollToTop"></titlePage>
    </div>

    <!-- 主要内容 -->
    <main class="main-content">
      <div class="content-wrapper">
        <!-- 标签切换：与订单等页一致的紧凑下划线样式 -->
        <div class="sub-nav-tabs"
             role="tablist">
          <button type="button"
                  class="sub-nav-tab"
                  role="tab"
                  :aria-selected="hover === 1"
                  @click="tabClick(1)"
                  :class="{ active: hover === 1 }">我的团队</button>
          <button type="button"
                  class="sub-nav-tab"
                  role="tab"
                  :aria-selected="hover === 2"
                  @click="tabClick(2)"
                  :class="{ active: hover === 2 }">团队佣金</button>
        </div>

        <!-- 团队表格 -->
        <div class="team-table"
             v-if="hover == 1">
          <table>
            <thead>
              <tr>
                <th>姓名</th>
                <th>手机号</th>
                <th>绑定时间</th>
                <th>团队级别</th>
              </tr>
            </thead>
            <tbody v-if="list.length">
              <tr v-for="(item, index) in list"
                  :key="index">
                <td class="cell-strong">{{ item.nickname }}</td>
                <td class="cell-mono">{{ item.tel }}</td>
                <td>{{ item.reg_time }}</td>
                <td>
                  <span class="level-tag"
                        :class="item.level == 1 ? 'level-tag--1' : 'level-tag--2'">
                    {{ item.level == 1 ? '一级' : '二级' }}
                  </span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="4"
                    class="empty-cell">暂无团队成员</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="team-table"
             v-if="hover == 2">
          <table>
            <thead>
              <tr>
                <th>结算人</th>
                <th>公司名称</th>
                <th>职位名称</th>
                <th>结算时间</th>
                <th>结算单号</th>
                <th>结算人次</th>
                <th>结算金额</th>
                <th>佣金收入(元)</th>
              </tr>
            </thead>
            <tbody v-if="list.length">
              <tr v-for="(item, index) in list"
                  :key="index">
                <td class="settler-cell">
                  <span class="settler-name">{{ item.settler_name }}</span>
                  <span class="dengji"
                        :class="item.referral_level == 1 ? 'color1' : 'color2'">{{ item.referral_level == 1 ? '一级' : '二级' }}</span>
                </td>
                <td class="cell-left">{{ item.company_name }}</td>
                <td class="cell-left">{{ item.position_name }}</td>
                <td>{{ item.settle_time }}</td>
                <td class="link-cell"
                    @click="getDetails(item)">{{ item.order_sn }}</td>
                <td>{{ item.settle_people }}</td>
                <td class="cell-num">{{ item.settle_amount }}</td>
                <td class="amount-cell">{{ item.commission }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="8"
                    class="empty-cell">暂无佣金记录</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>

    <!-- 页脚 -->
    <div class="footer-fixed">
      <fotterVue></fotterVue>
    </div>
  </div>
</template>

<script>
import titlePage from '@/components/titlePage.vue'
import fotterVue from '@/components/fotter.vue'
export default {
  name: 'AgentCenter',
  components: {
    titlePage,
    fotterVue,
  },
  data() {
    return {
      isSticky: false,
      stickyBoxTop: 0,
      isStatus: true,
      hover: 1,
      list: [],

      searchForm: {
        level: 0,
        page: 1,
        page_size: 10,
      },
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 这里可以添加需要的方法
    tabClick(e) {
      this.hover = e
      this.list = []
      this.searchForm.level = 0
      this.searchForm.page = 1
      if (this.hover == 1) {
        this.getList()
      } else {
        this.getList2()
      }
    },
    getDetails(item) {
      this.$router.push({
        path: '/AgentDetails',
        query: {
          id: item.id,
        },
      })
    },
    handleScroll(event) {
      const scrollTop = event.target.scrollTop
      this.isSticky = scrollTop > this.stickyBoxTop
      const bottomOfWindow =
        this.$refs.containerBox.scrollHeight -
        this.$refs.containerBox.scrollTop -
        this.$refs.containerBox.clientHeight
      // console.log(bottomOfWindow);
      if (this.isStatus == true && bottomOfWindow <= 50) {
        this.searchForm.page += 1
        this.isStatus = false
        if (this.hover == 1) {
          this.getList()
        } else {
          this.getList2()
        }
      }
    },
    getList() {
      if (this.searchForm.page == 1) {
        this.list = []
      }
      this.$api.index.getMyReferrals(this.searchForm).then((res) => {
        console.log(res, '666')
        this.loading = false
        if (res.code == 200) {
          this.list = [...this.list, ...res.data.list]
          this.isStatus = res.data.total > this.list.length ? true : false
        }
      })
    },
    getList2() {
      if (this.searchForm.page == 1) {
        this.list = []
      }
      this.$api.index.teamCommissionList(this.searchForm).then((res) => {
        console.log(res, '666')
        this.loading = false
        if (res.code == 200) {
          this.list = [...this.list, ...res.data.list]
          this.isStatus = res.data.total > this.list.length ? true : false
        }
      })
    },
    scrollToTop() {
      this.$refs.containerBox.scrollTop = 0
    },
  },
  created() {
    // 组件创建时的逻辑
  },
  mounted() {
    // 组件挂载时的逻辑
    this.scrollToTop()
    this.getList()
  },
}
</script>

<style lang="scss" scoped>
.agent-center {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

.footer-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

/* 导航栏样式 */

/* 主要内容样式 */
.main-content {
  flex: 1;
  background: linear-gradient(180deg, #e8f4ff 0%, #f6f8fe 28%, #f6f8fe 100%);
  padding: 40px 0 320px;
  margin-top: 60px;
}

.content-wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 子导航标签：左对齐、占宽随文案，与全站订单类页面一致 */
.sub-nav-tabs {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 4px 28px;
  margin-bottom: 14px;
  padding: 0 2px;
  //   border-bottom: 1px solid #e4e9ef;
}

.sub-nav-tab {
  position: relative;
  flex: 0 0 auto;
  margin: 0 0 -1px;
  padding: 8px 0 10px;
  border: none;
  background: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: #666;
  border-bottom: 2px solid transparent;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.sub-nav-tab:hover {
  color: #0092ff;
}

.sub-nav-tab.active {
  color: #0092ff;
  font-weight: 600;
  border-bottom-color: #0092ff;
}

.sub-nav-tab:focus {
  outline: none;
}

.sub-nav-tab:focus-visible {
  outline: 2px solid rgba(0, 146, 255, 0.45);
  outline-offset: 2px;
  border-radius: 2px;
}

/* 表格样式 */
.team-table {
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e4ebf3;
  box-shadow: 0 8px 32px rgba(15, 45, 90, 0.06);
}

.dengji {
  display: inline-block;
  vertical-align: middle;
  margin-left: 8px;
  padding: 2px 10px;
  min-height: 20px;
  line-height: 16px;
  border-radius: 4px;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
}

.color1 {
  background: #fa960f;
}

.color2 {
  background-color: #ff6232;
}

.level-tag {
  display: inline-block;
  padding: 4px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
}

.level-tag--1 {
  background: linear-gradient(135deg, #fa960f 0%, #e8830c 100%);
}

.level-tag--2 {
  background: linear-gradient(135deg, #ff6232 0%, #e54d22 100%);
}

.settler-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px 8px;
}

.settler-name {
  font-weight: 500;
  color: #1a1a1a;
}

.cell-strong {
  font-weight: 500;
  color: #1a1a1a;
}

.cell-mono {
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

.cell-left {
  text-align: left;
  max-width: 240px;
  padding-left: 20px;
  padding-right: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-num {
  font-variant-numeric: tabular-nums;
}

.link-cell {
  color: #0092ff;
  cursor: pointer;
  font-weight: 500;
  transition: opacity 0.2s ease;
}

.link-cell:hover {
  opacity: 0.85;
  text-decoration: underline;
}

.amount-cell {
  color: #0092ff;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.empty-cell {
  padding: 48px 24px !important;
  text-align: center;
  color: #8a939d;
  font-size: 14px;
  background: #fafbfd;
  border-bottom: none !important;
}

.team-table table {
  width: 100%;
  border-collapse: collapse;
}

.team-table th,
.team-table td {
  padding: 16px 14px;
  text-align: center;
  font-size: 14px;
}

.team-table th {
  background: linear-gradient(180deg, #dff2ff 0%, #e8f4ff 100%);
  color: #5a6670;
  font-weight: 600;
  border-bottom: 1px solid #d0e8f7;
}

.team-table td {
  color: #333333;
  border-bottom: 1px solid #eef1f5;
  transition: background 0.15s ease;
}

.team-table tbody tr:hover td {
  background: #f8fbff;
}

.team-table tbody tr:last-child td {
  border-bottom: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    padding: 0 15px;
  }

  .nav {
    display: none;
  }

  .content-wrapper {
    padding: 0 15px;
  }

  .main-content {
    padding: 20px 0;
  }

  .footer-content {
    padding: 0 15px;
    flex-direction: column;
    gap: 30px;
  }

  .footer-middle {
    gap: 30px;
    justify-content: space-between;
  }

  .team-table th,
  .team-table td {
    padding: 12px 8px;
    font-size: 12px;
  }

  .cell-left {
    max-width: 140px;
  }

  .footer-bottom {
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  .footer-middle {
    flex-direction: column;
    gap: 20px;
  }

  .team-table {
    overflow-x: auto;
  }

  .team-table table {
    min-width: 400px;
  }
}
</style>